import { jsxs, jsx } from "react/jsx-runtime";
import { parseISO, format, isToday } from "date-fns";
import { TIME_FORMAT, DATE_FORMAT } from "../../../../call-management.constants.js";
import { CallTaskState } from "../../../../call-management.types.js";
import { formatCounter, getUnsuccessfullCallbackTime } from "../../CallCard.helpers.js";
import { useCounter } from "../../CallCard.hooks.js";
import { TextWrapper, ClockIcon, StyledTypography } from "./CallCardCallbackTime.styles.js";
import "../../../TimerProvider/index.js";
import "react";
import "@mui/material";
import "@mui/material/styles";
import "../../../../assets/icons/Clock.js";
const getCallbackDetails = ({ action, solvedAt, currentState }, labels) => {
  if (solvedAt) {
    const solvedAtTimeFormat = parseISO(solvedAt);
    const solvedTime = format(solvedAtTimeFormat, TIME_FORMAT);
    const solvedDate = format(solvedAtTimeFormat, DATE_FORMAT);
    const solvedToday = isToday(solvedAtTimeFormat);
    const timeDetails = `${!solvedToday ? `${solvedDate}, ` : ""}${solvedTime}`;
    if (currentState === CallTaskState.Done || currentState === CallTaskState.Done_AvailyBooking) {
      const label = solvedToday ? labels.calledToday : labels.calledPast;
      return `${label} ${timeDetails}`;
    }
    if (currentState === CallTaskState.Ignored) {
      const label = solvedToday ? labels.ignoredToday : labels.ignoredPast;
      return `${label} ${timeDetails}`;
    }
  }
  const unsuccessfullCallbackTime = getUnsuccessfullCallbackTime(action);
  if (unsuccessfullCallbackTime) {
    const callbackTimeFormat = parseISO(unsuccessfullCallbackTime);
    const callbackTime = format(callbackTimeFormat, TIME_FORMAT);
    const callbackDate = format(callbackTimeFormat, DATE_FORMAT);
    const callbackToday = isToday(callbackTimeFormat) ? "today" : "past";
    const timeDetails = `${!callbackToday ? `${callbackDate},` : ""} ${callbackTime}`;
    let label = callbackToday ? labels.calledToday : labels.calledPast;
    if (currentState === CallTaskState.Open_UnsuccessfulCallback) {
      label = callbackToday ? labels.notReachedToday : labels.notReachedPast;
    }
    return `${label} ${timeDetails}`;
  }
  return "";
};
const CallCardCallbackTime = ({ data, labels }) => {
  const { currentState, callbackRequiredAt } = data;
  const isOpen = currentState === CallTaskState.Open;
  const inProgress = currentState === CallTaskState.Open_InProgress;
  const isRinging = currentState === CallTaskState.Open_Ringing;
  const isDone = currentState === CallTaskState.Done || currentState === CallTaskState.Done_AvailyBooking;
  const isIgnored = currentState === CallTaskState.Ignored;
  const isWithCallback = currentState === CallTaskState.Open_UnsuccessfulCallback;
  const showCounter = isOpen || inProgress || isRinging;
  const counter = useCounter(callbackRequiredAt, { disabled: !showCounter });
  const formattedCounter = formatCounter(counter, labels);
  const showClockIcon = !isDone && !isIgnored && !isWithCallback;
  const callbackTimeDetails = showCounter ? formattedCounter : getCallbackDetails(data, labels);
  return /* @__PURE__ */ jsxs(TextWrapper, { children: [
    showClockIcon && /* @__PURE__ */ jsx(ClockIcon, {}),
    /* @__PURE__ */ jsx(StyledTypography, { variant: "Lato Caption", status: currentState, isLate: counter.isLate, children: callbackTimeDetails })
  ] });
};
export {
  CallCardCallbackTime
};
